<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="380px"
    :before-close="handleClose"
    :close-on-click-modal="canClose"
  >
    <div class="bind-box">
      <div class="bind-title">绑定原登录账号</div>
      <template v-if="avatar">
        <img :src="avatar" class="bind-avatar" />
      </template>
      <template v-else>
        <img src="~@/images/user_avatar.png" class="bind-avatar" />
      </template>
      <div class="bind-phone">{{ phone | hidePhone }}</div>
      <div class="bind-fill_box">
        <div class="fill-line">
          <div class="fill-label">手机号：</div>
          <div class="fill-cont">
            <el-input
              v-model="bindPhone"
              style="width: 210px"
              placeholder="请输入手机号"
            ></el-input>
          </div>
        </div>
        <div class="fill-line">
          <div class="fill-label">验证码：</div>
          <div class="fill-cont">
            <el-input
              v-model="bindCode"
              style="width: 120px"
              placeholder="请输入验证码"
            ></el-input>
            <span class="get-code" @click="clickCodeBtn">{{
              isCounting ? timeCount + "s" : "获取验证码"
            }}</span>
          </div>
        </div>
      </div>
      <div class="bind-submit" @click="clickSubmit">提交</div>
    </div>
  </el-dialog>
</template>
<script>
import { mapState } from "vuex";
import codeMixin from "@/mixins/codeMixin";
import todoMixin from "@/mixins/todoMixin";
import { fetchSendSms, fetchUserBind } from "@/api/user";
export default {
  name: "WorkbenchBindAdmin",
  mixins: [codeMixin, todoMixin],
  computed: {
    ...mapState("user", [
      "phone",
      "avatar",
      "name",
      "login_todo",
      "platform",
      "redirect",
      "role",
      "common_token",
    ]),
    canClose() {
      return false;
    },
  },
  data() {
    return {
      dialogVisible: true,
      bindPhone: "",
      bindCode: "",
    };
  },
  mounted() {},
  methods: {
    checkSms() {
      const { bindPhone } = this;
      if (!bindPhone) {
        this.$message({
          message: "请输入手机号",
          type: "error",
        });
        return false;
      }
      return true;
    },
    fetchSmsApi() {
      const { bindPhone } = this;
      fetchSendSms({
        phone: bindPhone,
      });
    },
    handleClose() {
      setTimeout(() => {
        this.$router.replace({
          name: "WorkbenchHome",
        });
      }, 200);
    },
    clickSubmit() {
      const { bindPhone, bindCode, platform, role, common_token } = this;

      this.$confirm("确认绑定吗？")
        .then(() => {
          fetchUserBind({
            platform,
            role,
            common_token,
            phone: bindPhone,
            code: bindCode,
            is_bind: 0,
          }).then((res) => {
            const { code, data } = res;
            if (code === 0) {
              const { do: todo } = data;
              this.handleTodo(todo);
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>
